module.exports = __webpack_public_path__ + "static/media/g-5-d.51cffb3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-5-d.jpg
// module id = 1143
// module chunks = 33